module.exports = __webpack_public_path__ + "static/img/packaged-turbofuel_256.58aa3bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packaged-turbofuel_256.png
// module id = 3dZ5
// module chunks = 0